import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { WallboardViewService } from '../wallboard-view.service';
import { WVCustom, WVMain } from '../wallboard-view.model';
import { TextSettingsTransferObj, ModuleType } from '../../wallboards.model';

@Component({
    selector: 'cv-wallboard-view-custom-text',
    templateUrl: './wallboard-view-custom-text.component.html',
    styleUrls: ['./wallboard-view-custom-text.component.scss']
})
export class WallboardViewCustomTextComponent implements OnInit, OnDestroy {
    @Input() index;
    @Input() height;
    @Input() width;
    @Input() firstSlide;

    public wvf: WVMain;
    public wvcf: WVCustom;
    public textState: TextSettingsTransferObj;

    public slideError: boolean = false;
    private divSize: number;
    private divElem: JQuery<HTMLElement>;
    private divMax: number;
    private divWidth: number;
    private divMaxWidth: number;

    private isDestroyed: boolean = false;
    private _hasBackdrop: boolean = false;
    private _moduleKey: string = "";

    get hasBackdrop(): boolean {
        return this._hasBackdrop;
    }

    get moduleKey(): string {
        return this._moduleKey;
    }


    constructor(
        private service: WallboardViewService
    ) { }

    ngOnInit(): void {
        this.wvf = this.service.WVMain;
        this.wvcf = this.service.WVCustom;
        this.slideError = false;

        this._hasBackdrop = this.wvcf?.Slide.HasBackdrop ?? false;
        this._moduleKey = this.wvcf?.Slide.WallboardModuleDetails[this.index].WallboardModuleKey ?? "";

        this.service.loadModuleState(ModuleType.Text, this.wvf.WallboardCreatorID, this.moduleKey).then(response => {
            if (this.isDestroyed)
                return;

            this.textState = response.textObj;

            const containerList = $('.wvTextItem-' + this.moduleKey);
            const container = this.firstSlide ? containerList.first() : containerList.last();
            const $newItem = $(this.textState.TextValue);

            container.empty().append($newItem);

            setTimeout(() => {
                let divElemList = $('.wvTextItem-' + this.moduleKey);
                this.divElem = this.firstSlide ? divElemList.first() : divElemList.last();
                this.divElem.find('[style*="font-size"]').css('font-size', '');
                this.divMax = this.divElem.parent().height();
                this.divMaxWidth = this.divElem.parent().width();
                this.divSize = this.divElem.height();
                this.divWidth = this.divElem.width();

                this.divElem.css('visibility', 'hidden');
                this.setTextSize();
            }, 0);

            if (!this.firstSlide)
                this.wvcf.ReadyModules.push(this.moduleKey);
        });
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    async setTextSize() {
        if (this.divElem.children().length > 0 && this.divElem.children().is('h1, h2, h3, h4, h5, h6')) {
            this.divElem.css('visibility', 'visible');
            return;
        }
        while (this.divSize < this.divMax && this.divWidth <= this.divMaxWidth) {
            this.divElem.css('font-size', +this.divElem.css('font-size').slice(0, -2) - 0 + 5 + 'px');
            this.divSize = this.divElem.height();
            this.divWidth = this.divElem.width();

            if (this.divSize === 0)
                return;
        }

        while (this.divSize > this.divMax || this.divWidth > this.divMaxWidth) {
            this.divElem.css('font-size', +this.divElem.css('font-size').slice(0, -2) - 1 + 'px');
            this.divSize = this.divElem.height();
            this.divWidth = this.divElem.width();
        }

        this.divElem.css('visibility', 'visible');
    }
}
